import React, {Component} from 'react'
import {getTotalItemStatisticsByTypes} from "../../services/api/apiNextBox"
import FilterByHumanTime from "./FilterByHumanTime"
import classNames from 'classnames'
import changeNumberFormat from "../helpers/changeNumberFormat"

class StatisticsByTypes extends Component {
    state = {
        stats: [],
        filter: {
            time: 'today'
        },
        loading: false,
        error: '',
    }

    componentDidMount() {
        this._fetchTotalItemStatistics()
    }

    _fetchTotalItemStatistics = async () => {
        if (this.state.loading) return true

        this.setState({
            loading: true,
            error: ''
        })

        try {
            const {filter} = this.state
            const {success, data, message} = await getTotalItemStatisticsByTypes(filter)

            if (!success) {
                throw new Error(message)
            }

            this.setState({
                stats: Array.isArray(data) ? data : [],
                loading: false,
                error: ''
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message,
            })
        }
    }

    _handleChangeFilter = async (filter) => {
        return new Promise(resolve => {
            this.setState({
                filter,
            }, resolve)
        })
    }

    _handleSubmit = async () => {
        return this._fetchTotalItemStatistics()
    }

    _checkOptionFilter = (time) => {
        if (time === 'last-3-days') {
            return 3
        } else if (time === 'last-7-days') {
            return 7
        } else if (time === 'last-14-days') {
            return 14
        }
    }

    render() {
        const {stats, filter, loading} = this.state
        const arrTotal = stats.map(item => item.total)
        const totalProducts = arrTotal.reduce(
            (accumulator, currentValue) => accumulator + currentValue,
            0
        )


        return (
            <div className={classNames("StatisticsByDays", {loading})}>
                <h3>Tổng sản phẩm theo loại</h3>

                <FilterByHumanTime
                    loading={loading}
                    onChange={this._handleChangeFilter} onSubmit={this._handleSubmit} filter={filter}/>

                <div className="d-flex align-content-center justify-content-between">
                    {
                        (((filter.time !== 'yesterday') && (filter.time !== 'today')) && totalProducts > 0) &&
                        <div className="total mt-2 mb-2">Trung bình
                            <strong className='ml-1 mr-1'>
                                {changeNumberFormat(Math.round(totalProducts / this._checkOptionFilter(filter.time)), 0)}
                            </strong>sản phẩm / ngày
                        </div>
                    }
                    {
                        totalProducts > 0 ? (
                                <div className="total mt-2 mb-2 mr-3">Tổng số
                                    <strong className='ml-1 mr-1'>
                                        {changeNumberFormat(totalProducts)}
                                    </strong>
                                    sản phẩm</div>) :
                            <div className="total mt-2 mb-2">Tổng số 0 sản phẩm</div>
                    }
                </div>

                <table className="table border">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>Loại</th>
                        <th>Tổng hàng</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        stats.map((stat, index) => {
                            const {_id, total} = Object.assign({}, stat)

                            return (
                                <tr key={_id}>
                                    <td>{index + 1}</td>
                                    <td>{_id}</td>
                                    <td>{changeNumberFormat(total)}</td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
            </div>
        )
    }
}

export default StatisticsByTypes
